// apps/backoffice/src/app/not-found.tsx
'use client';

import { Box, Typography, Button } from '@mui/material';
import { useRouter } from 'next/navigation';
import { useI18n } from '@tourtask/i18n/client/contexts/I18nContext';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

export default function NotFoundPage() {
  const router = useRouter();
  const t = useTranslations('common');
  const { getUrl } = useI18n();

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="60vh"
        textAlign="center"
        sx={{ gap: 2 }}
      >
        <Image
          src="/images/tourtask-logo-fallen-100x89.png"
          width={100}
          height={89}
          alt="TourTask logo Fallen"
        />
        <Typography variant="h4" fontWeight="bold">
          {t('Page_not_found')}
        </Typography>
        <Typography variant="body1" color="text.secondary" maxWidth={400}>
          {t('The_page_you_are_looking_for_does_not_exist')}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => router.push(getUrl({ code: '_ROOT_' }))}
        >
          {t('Return_to_dashboard')}
        </Button>
      </Box>
    </>
  );
}
